import * as React from 'react';
import * as styles from './styles.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { Icon } from '@fluentui/react/lib/Icon';
import type { ITextFieldStyles } from '@fluentui/react/lib/TextField';
import { ControlIcons } from 'owa-control-icons';
import { Droppable } from 'owa-dnd';
import type { SubTasksViewProps } from '../schema';
import { subtaskPlaceholder } from '../taskStrings.locstring.json';
import useAddSubTaskViewState from '../hooks/useAddSubTaskViewState';
import loc from 'owa-localize';
import { TextFieldWithHiddenLabel } from 'owa-timestream-asset-sdk';

const textFieldStyles: Partial<ITextFieldStyles> = {
    root: styles.subtaskTitle,
    field: styles.newSubtaskInput,
    fieldGroup: styles.subtaskFieldGroup,
};

export default observer(function AddSubtaskView(props: SubTasksViewProps) {
    const { textFieldProps, droppableProps } = useAddSubTaskViewState(props);

    return (
        <Droppable
            {...droppableProps}
            classNames={classNames(styles.addSubtaskField, styles.droppableSubtask, {
                [styles.dropHint]: droppableProps.dropViewState.isDragOver,
            })}
            preventBubblingDragEvents={true}>
            <div className={styles.subtask}>
                <Icon
                    iconName={ControlIcons.Add}
                    className={classNames(styles.addIcon, {
                        [styles.addIconDisabled]: !!props.disableSubtasks,
                    })}
                />
                <TextFieldWithHiddenLabel
                    {...textFieldProps}
                    borderless={true}
                    multiline={true}
                    autoAdjustHeight={true}
                    resizable={false}
                    placeholder={loc(subtaskPlaceholder)}
                    styles={textFieldStyles}
                />
            </div>
        </Droppable>
    );
});
